import { createInstance } from 'localforage';

import { Logger } from './Logger';

export function createSessionLogger(name = 'session'): Logger {
  const loggerStorage = createInstance({
    name,
    storeName: 'logs',
  });

  loggerStorage.clear().catch(console.error);

  function log(...messages: unknown[]): void {
    loggerStorage
      .setItem(Date.now().toString(), ['[LOG]', ...messages].join(' '))
      .catch(console.error);
  }

  function warn(...messages: unknown[]): void {
    loggerStorage
      .setItem(Date.now().toString(), ['[WARN]', ...messages].join(' '))
      .catch(console.error);
  }

  function info(...messages: unknown[]): void {
    loggerStorage
      .setItem(Date.now().toString(), ['[INFO]', ...messages].join(' '))
      .catch(console.error);
  }

  function error(...messages: unknown[]): void {
    loggerStorage
      .setItem(Date.now().toString(), ['[ERROR]', ...messages].join(' '))
      .catch(console.error);
  }

  return { log, warn, info, error };
}
